module.exports = __webpack_public_path__ + "img/ione7.ff101242.png";